<template>
  <div class="third">
    <div class="third-formOne ReasonsFoRreporting">
      <div class="formOne-btn">
        <div class="btn-left">
          <div>
            <div class="btn-left">
              <span class="left-back-icon" @click="goBack">
                <i class="el-icon-arrow-left"></i>
                <span class="left-back-title">返回</span>
              </span>
              <span class="left-back-shu">
                <span class="left-back-shu-content"></span>
              </span>
              <span class="left-back-content">举报原因</span>
            </div>
          </div>
        </div>
        <div class="btn-right">
          <el-button class="btn-two" type="primary" @click="Preservation">保存</el-button>
          <el-button class="btn-two" type="default" @click="Reset">重置</el-button>
        </div>
      </div>
      <div class="formOne-forms" style="margin-top: 57px;">
        <div class="forms-one">
          <div class="one-list">
            <el-form label-width="86px">
              <div class="list-one-line">
                <el-form-item
                  v-for="(item,index) in getselectdata"
                  :key="index+1"
                  :label="String(index+1)+'丶'"
                >
                  <el-input
                    class="list-input"
                    :maxlength="30"
                    v-model="item.content"
                    placeholder="请输入"
                  ></el-input>
                  <el-input
                    style="margin-left:10px"
                    class="list-input"
                    :maxlength="30"
                    v-model="item.contentEn"
                    placeholder="英文版，不填默认使用中文版内容"
                  ></el-input>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getReportReasonList,
  saveReportReasonConfigList
} from "@/store/mymethod/ReportingManagement"; //我的

export default {
  name: "formSeven",
  data() {
    return {
      getselectdata: [] //原因列表
    };
  },
  created() {},
  mounted() {
    this.getReportReasonList();
  },
  methods: {
    //返回
    goBack() {
      this.$emit("backHome", "");
    },
    //获取举报原因列表
    getReportReasonList() {
      try {
        getReportReasonList().then(res => {
          const data = res.data;
          console.log("原来下拉列表", data);
          if (data.status === 1000) {
            this.getselectdata = data.result;
            let fornumber = 10 - this.getselectdata.length;
            for (let i = 0; i < fornumber; i++) {
              this.getselectdata.push({ content: "", contentEn: "" });
            }
            console.log(this.getselectdata);
          }else{
            this.$message.error(data.msg)
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //保存
    Preservation() {
      // console.log(this.getselectdata);
      // 添加验证 zou
      const { getselectdata } = this;
      let isFull = true;
      getselectdata.forEach((element) => {
        if (!element.content && element.contentEn) {
          isFull = false
        }
      })
      if (!isFull) return this.$message.error('请填写完整内容')
      try {
        const params = {
          dataList: getselectdata
        };
        saveReportReasonConfigList(params).then(res => {
          const data = res.data;
          if (data.status === 1000) {
            this.goBack();
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          }else{
            this.$message.error(data.msg)
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //重置
    Reset() {
      this.getReportReasonList();
    },
    //------------------------------------------------------------

    //表单验证
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //表单重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style lang="scss">
.ReasonsFoRreporting {
  .el-input {
    width: 100%;
  }
}
</style>
